import { render } from "./utilizadoresView.vue?vue&type=template&id=07f94b7f"
import script from "./utilizadoresView.vue?vue&type=script&lang=js"
export * from "./utilizadoresView.vue?vue&type=script&lang=js"

import "./utilizadoresView.vue?vue&type=style&index=0&id=07f94b7f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__